import szukaj from '@components/search/inputs/szukaj'
import stan from '@components/search/inputs/stanCzesci'
import cena from '@components/search/inputs/cena'
import lokalizacja from '@components/search/inputs/lokalizacjaZasieg'
import rodzaj from '@components/search/inputs/rodzajTool'
import kategoria from '@components/search/inputs/kategoriaTool'

const toolFormInputsMobile = [
    rodzaj,
    kategoria,
    cena,
    lokalizacja,
    stan,
    szukaj,
]

const toolFormInputs = [
    szukaj,
    stan,
    cena,
    rodzaj,
    kategoria,
    lokalizacja,
]

export {
    toolFormInputsMobile,
    toolFormInputs,
}